module.exports = __webpack_public_path__ + "static/media/LNweb.7b3bf7b4.PNG";